import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../card/Card";
import { TabsContent } from "../tabs/Tabs";

const OverviewTabContent = ({
  value,
  title,
  titleOptions = {},
  description,
  descriptionOptions = {},
  subDescription = null,
  subDescriptionOptions = {},
  options = null,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <TabsContent value={value}>
      <Card>
        <CardHeader>
          <div className="flex flex-row justify-between">
            <div className="flex flex-col gap-y-1">
              <CardTitle>{t(title, titleOptions)}</CardTitle>
              <CardDescription>
                {t(description, descriptionOptions)}
                {subDescription && (
                  <p>{t(subDescription, subDescriptionOptions)}</p>
                )}
              </CardDescription>
            </div>
            {options}
          </div>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </TabsContent>
  );
};

export default OverviewTabContent;
